module.exports = __webpack_public_path__ + "themes/fq/sprite/green-button.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/sprite/green-button.png
// module id = 70
// module chunks = d-game